import forEach from 'lodash/forEach';
import * as constants from './constants';
import defaultState from '../state';
import { dirify } from '../utils/dirify';

const notificationsInitialState = defaultState.notifications;

const getDealType = search => {
  const defaultDealType = 1;
  try {
    return search.attributes.query.vertical_properties.deal_type || defaultDealType;
  } catch (error) {
    return defaultDealType;
  }
};

const getDealTypeKey = search => `dealType${getDealType(search)}`;

export const formatSearch = search => ({
  what: search.attributes.query.what,
  id: search.id,
  dealType: getDealType(search),
  filters: search.attributes.query.filters,
  isActive: search.attributes.active,
});

export const processSearchesData = searches => {
  const res = {};
  forEach(searches, search => {
    const dealTypeKey = getDealTypeKey(search);
    const what = search.attributes.query.what;
    const formattedSearch = formatSearch(search);

    if (res[dealTypeKey]) {
      res[dealTypeKey][dirify(what)] = formattedSearch;
    } else {
      res[dealTypeKey] = {
        [dirify(what)]: formattedSearch,
      };
    }
  });
  return res;
};

export default (state = notificationsInitialState, action) => {
  switch (action.type) {
    case constants.RESTORE_USER_SUBSCRIPTION:
    case constants.SUSCRIPTION_USER:
    case constants.SAVE_NOTIFICATION_SEARCH:
    case constants.UPDATE_NOTIFICATION_SEARCH:
      return { ...state, error: null };
    case constants.FETCH_NOTIFICATION_SEARCHES:
      return { ...state, isFetching: true, error: null };

    case constants.RESTORE_USER_SUBSCRIPTION_SUCCESS:
    case constants.FETCH_NOTIFICATION_SEARCHES_SUCCESS:
    case constants.SUSCRIPTION_USER_SUCCESS: {
      const { user, search } = action.data;
      const searches = processSearchesData(search);

      return {
        ...state,
        error: null,
        isExpired: false,
        searches,
        infrastructureId: user.attributes.infrastructure_id,
        subscriptionId: user.id,
      };
    }

    case constants.RESET_USER_SUBSCRIPTION: {
      return { ...notificationsInitialState, reset: true };
    }

    case constants.SET_NOTIFICATION_SUBSCRIPTIONID: {
      const { id } = action.data;
      return {
        ...state,
        error: null,
        subscriptionId: id,
      };
    }

    case constants.UPDATE_USER_SUBSCRIPTION_SUCCESS: {
      const { user } = action.data;

      return {
        ...state,
        error: null,
        isExpired: false,
        infrastructureId: user.attributes.infrastructure_id,
        subscriptionId: user.id,
      };
    }

    case constants.SAVE_NOTIFICATION_SEARCH_SUCCESS: {
      const search = action.data;
      const formattedSearch = formatSearch(search);
      const whatDirified = dirify(search.attributes.query.what);
      const dealTypeKey = getDealTypeKey(search);

      return {
        ...state,
        error: null,
        searches: {
          ...state.searches,
          [dealTypeKey]: {
            ...state.searches[dealTypeKey],
            [whatDirified]: {
              ...state.searches[dealTypeKey][whatDirified],
              ...formattedSearch,
            },
          },
        },
      };
    }

    case constants.UPDATE_NOTIFICATION_SEARCH_SUCCESS: {
      const search = action.data;
      const whatDirified = dirify(search.attributes.query.what);
      const dealTypeKey = getDealTypeKey(search);
      const filters = search.attributes.query.filters;
      const isActive = search.attributes.active;

      return {
        ...state,
        error: null,
        searches: {
          ...state.searches,
          [dealTypeKey]: {
            ...state.searches[dealTypeKey],
            [whatDirified]: {
              ...state.searches[dealTypeKey][whatDirified],
              filters,
              isActive,
            },
          },
        },
      };
    }

    case constants.FETCH_NOTIFICATION_SEARCHES_FAILED:
      return { ...state, isExpired: true, error: action.error };

    case constants.SUSCRIPTION_USER_FAILED:
    case constants.SAVE_NOTIFICATION_SEARCH_FAILED:
    case constants.UPDATE_NOTIFICATION_SEARCH_FAILED:
    case constants.RESTORE_USER_SUBSCRIPTION_FAILED:
      return { ...state, error: action.error };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Notifications/reducer.js